export default class BotsService {

    constructor(apiUrl = "https://messaging-bot.iot.freeutg.com/api") {
        this.apiUrl = apiUrl;
    }

    async getDevice(devEUI) {
        const response = await fetch(this.apiUrl + "/dev_eui/" + devEUI);
        return response.status == 200 ? await response.json() : null;
    }

    async fetchDevices() {
        const response = await fetch(this.apiUrl + "/devices");
        return await response.json();
    }

}